export const ALL_VEHICLES_LISTING_SECTION_ID = '1'
export const SECOND_HAND_VEHICLES_LISTING_SECTION_ID = '2'
export const NEW_VEHICLES_LISTING_SECTION_ID = '3'
export const KM0_VEHICLES_LISTING_SECTION_ID = '4'
export const VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID = '5'
export const RENTING_VEHICLES_LISTING_SECTION_ID = '6'
export const AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID = '7'
export const CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID = '8'
export const NO_LICENSE_VEHICLES_LISTING_SECTION_ID = '9'
export const QUADS_AND_ATVS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID = '10'
export const BUGGIES_SECOND_HAND_VEHICLES_LISTING_SECTION_ID = '11'
export const MINIMOTOS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID = '12'
export const CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID = '13'
export const QUADS_AND_ATVS_NEW_VEHICLES_LISTING_SECTION_ID = '14'
export const BUGGIES_NEW_VEHICLES_LISTING_SECTION_ID = '15'
export const MINIMOTOS_NEW_VEHICLES_LISTING_SECTION_ID = '16'
export const QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_ID = '17'
export const BUGGIES_VEHICLES_LISTING_SECTION_ID = '18'
export const MINIMOTOS_VEHICLES_LISTING_SECTION_ID = '19'
export const FAVORITES_VEHICLES_LISTING_SECTION_ID = '20'
export const ALERT_MATCHES_VEHICLES_LISTING_SECTION_ID = '21'

export const LISTING_SECTION_IDS = {
  ALL_VEHICLES: ALL_VEHICLES_LISTING_SECTION_ID,
  AUTOCARAVANS_AND_TRAILERS_VEHICLES: AUTOCARAVANS_AND_TRAILERS_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_NEW_VEHICLES: BUGGIES_NEW_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_SECOND_HAND_VEHICLES: BUGGIES_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  BUGGIES_VEHICLES: BUGGIES_VEHICLES_LISTING_SECTION_ID,
  CLASSIC_AND_COMPETITION_VEHICLES: CLASSIC_AND_COMPETITION_VEHICLES_LISTING_SECTION_ID,
  CLASSIC_MOTOS_VEHICLES: CLASSIC_MOTOS_VEHICLES_LISTING_SECTION_ID,
  DEFAULT_LISTING_SECTION_ID: ALL_VEHICLES_LISTING_SECTION_ID,
  KM0_VEHICLES: KM0_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_NEW_VEHICLES: MINIMOTOS_NEW_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_SECOND_HAND_VEHICLES: MINIMOTOS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  MINIMOTOS_VEHICLES: MINIMOTOS_VEHICLES_LISTING_SECTION_ID,
  NEW_VEHICLES: NEW_VEHICLES_LISTING_SECTION_ID,
  NO_LICENSE_VEHICLES: NO_LICENSE_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_NEW_VEHICLES: QUADS_AND_ATVS_NEW_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_SECOND_HAND_VEHICLES: QUADS_AND_ATVS_SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  QUADS_AND_ATVS_VEHICLES: QUADS_AND_ATVS_VEHICLES_LISTING_SECTION_ID,
  RENTING_VEHICLES: RENTING_VEHICLES_LISTING_SECTION_ID,
  SECOND_HAND_VEHICLES: SECOND_HAND_VEHICLES_LISTING_SECTION_ID,
  VANS_AND_COMMERCIAL_VEHICLES: VANS_AND_COMMERCIAL_VEHICLES_LISTING_SECTION_ID,
  FAVORITES_VEHICLES: FAVORITES_VEHICLES_LISTING_SECTION_ID,
  ALERT_MATCHES_VEHICLES: ALERT_MATCHES_VEHICLES_LISTING_SECTION_ID
}
